import AppLink from '@theme/components/atom/AppLink'
import AppTitle from '@theme/components/atom/AppTitle'
import Container from '@theme/components/utils/Container'
import HeadingLevel from '~/mixins/HeadingLevel'
import UtilityGridMixin from '~/mixins/UtilityGridMixin'

export default {
  mixins: [HeadingLevel, UtilityGridMixin],
  components: {
    AppLink,
    AppTitle,
    Container,
  },
  data() {
    return {
      columnGridClass: '',
    }
  },
  props: {
    items: Array,
  },
  created() {
    this.columnGridClass = this.computeColumnClass(this.$themeSettings.components.MenuHorizontal.countPerLine)
  },
}
